import React from "react"
import styles from "./../Errors.module.scss"
import { Layout } from "antd"
import { cdn } from "core/cdn"

const DocumentNotFound: React.FC<unknown> = (): JSX.Element => {
  return (
    <Layout className={styles.Layout}>
      <div className={styles.NotFound} data-testid="DocumentNotFound">
        <img
          className={styles.Logo}
          src={cdn("/images/upload_failed.svg")}
          alt="failed upload"
        />
        <h1 className={styles.Title}>Une erreur est survenue lors de la récupération du document</h1>
      </div>
    </Layout>
  )
}

export default DocumentNotFound
